import React from "react";

import API from "@beardeddevops/react.api";
import Framework from '@beardeddevops/react.framework';
import Types from "constants/Types";
import TransactionCollection from "components/TransactionCollection";
import TransactionType from "../../constants/TransactionTypes";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";

export default class Imports extends TransactionCollection {
	constructor(props) {
		let model = new API.BuildClass(Types.Transactions._name, API.RequestType.READ_ALL);
		super(props, model);
		this.request = 'GET_IMPORTS';
		this.model.set = TransactionType.Acquisition;
	}

	componentDidMount() {
		if (location.hash && location.hash.substr(1)) {
			this.setState({search: location.hash.substr(1)});
		}
	}

	render() {
		const {loading} = this.state;
		return (
			<Card>
				<CardContent>
					{super.render('Imports', 'acquisitions', "Seller")}

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}